GP.GPMod('Galleries',function(self) {

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;
        },
        next_page: 1,
        sort_type: '',
        range_type: '',
        gallery_type: 'pictures'
    };

    var conf = {
        url: {
            pictures: '/members/content/pictures',
            videos: '/members/content/videos'
        }
    };

    this.content_collection = new self.app.collections.Content();
    this.load_more = false;
    this.filter_type = '';
    this.fetching_content = false;

    var apis = {
        get_content: function(caller) {
            if (!self.fetching_content) {
                self.fetching_content = true;
                var fetch_url = _data.gallery_type == 'pictures' ? conf.url.pictures : conf.url.videos;

                $.post(fetch_url, {
                    get_content: 1,
                    page:        _data.next_page,
                    sort_type:   _data.sort_type,
                    range_type:  _data.range_type
                }).done(function(json) {
                    self.content_collection.add(json.content);

                    // Update next page number
                    if (typeof(json.next_page) !== 'undefined') {
                        _data.next_page = json.next_page;
                    }
                    
                    self.load_more = json.show_load_more;
                    self.fetching_content = false;

                    vent.trigger('ContentViewerLayout:next_content');
                });
            }
        }        
    };

    var events = {
        init: function() {
            vent.on('init_js:content:pictures init_js:content:videos', events.setup_content);
            vent.on(self.moduleName + ":more_content", events.more_content);

            GP.reqres.setHandler(self.moduleName+':get_has_more', function() {
                return self.load_more;
            });
        },
        setup_content: function() {
            events.setup_binds();

            if (GP.Util.check_location('/content/pictures') && typeof photo_gal_content !== 'undefined') {
                if (!_.isEmpty(photo_gal_content)) {
                    self.content_collection.reset();
                    self.content_collection.add(photo_gal_content.content);
                    _data.next_page = photo_gal_content.next_page;
                    _data.sort_type = photo_gal_content.sort_type;
                    _data.range_type = photo_gal_content.range_type;
                    self.load_more = photo_gal_content.show_load_more;
                }
                _data.gallery_type = 'pictures';
            }

            if (GP.Util.check_location('/content/videos') && typeof video_gal_content !== 'undefined') {
                if (!_.isEmpty(video_gal_content)) {
                    self.content_collection.reset();
                    self.content_collection.add(video_gal_content.content);
                    _data.next_page = video_gal_content.next_page;
                    _data.sort_type = video_gal_content.sort_type;
                    _data.range_type = video_gal_content.range_type;
                    self.load_more = video_gal_content.show_load_more;
                }
                _data.gallery_type = 'videos';
            }
        },
        setup_binds: function() {
            $('.btn-gallery-upload').on('click', function() {
                $('#content-file-input').trigger('click');
            });
        },
        more_content: function() {
            apis.get_content();
        }
      };
    this.addInitializer(function() {
        _data.init();
        events.init();
    });      
});

/*
OLD CODE BASE BACKUP

          var currentPage = <?= $current_page ?>;
          <?php foreach($pictures as $key => $pic) $pic_ids[] = $pic['media_id']; ?>
          var thumbIDs = [<?= implode(",",$pic_ids) ?>];
          var activeID = <?= $media_id ?>;
          var lastPage = <?= ($pages['next']) ? 'false' : 'true' ?>;

  function changeActive(domobj)
          {
      var thumbHolder = document.getElementById('thumbHolder');
      var thumbs = thumbHolder.getElementsByTagName('a');
      
      for(var i=0; i<thumbs.length; i++)
      {
          if(thumbs[i].id == 'isActive')
              thumbs[i].id = '';
          
          if(thumbs[i] == domobj)
          {
                      activeID = thumbs[i].name;
              thumbs[i].id = "isActive";
          }
      }
              togglePrevNext();
  }
  function togglePrevNext()
          {
              var prevTop = document.getElementById('prevTop');
              var nextTop = document.getElementById('nextTop');
              if(currentPage == 1 && activeID == thumbIDs[0])
              {
                  prevTop.innerHTML= '&lsaquo; <?= __('prev', 'b') ?>';   
              } else
              {
                  prevTop.innerHTML='<a href="#" class="prevNext" onclick="goNextPrev(-1); return false;">&lsaquo; <?= __('prev', 'b') ?></a>';
              }
              if(lastPage == true && activeID == thumbIDs[thumbIDs.length-1])
              {
                  nextTop.innerHTML= '<?= __('next', 'b') ?> &rsaquo;';
              } else
              {
                  nextTop.innerHTML='<a href="#" class="prevNext" onclick="goNextPrev(); return false;"><?= __('next', 'b') ?> &rsaquo;</a>';
              }
          }
  function goNextPrev(goPrev)
  {
      direction = 1;
      if(goPrev)
      {
          direction = -1;
      }
      
      var thumbHolder = document.getElementById('thumbHolder');
      var thumbs = thumbHolder.getElementsByTagName('a');
      var iframe = document.getElementById('picFrame');
      var pagejump = false;
      
      for(var i=0; i<thumbs.length; i++)
      {
          if(thumbs[i].id == "isActive"){
          
              var newThumb = thumbs[i+direction];
          
              if((i+direction > thumbs.length-1 || newThumb.className != 'picThumb'))
                      {
                  pagejump = true;
              }
              
              if(pagejump === false)
              {
                 iframe.src = newThumb.href;
                 changeActive(newThumb);
                 break;
              }
              else
              {
                  var next = document.getElementById('nextPage');
                  var prev = document.getElementById('prevPage');
                  var newLoc = false;
                  
                  if(direction == -1)
                  {
                      if(prev)
                      {
                          newLoc = prev.href+"&isprev=1";
                      }
                      else
                      {
                          return false;
                      }
                  }
                  else
                  {
                      if(next)
                      {
                          newLoc = next.href;
                      }
                      else
                      {
                          return false;
                      }
                  }
                  
                  window.location = newLoc;
              }
          }
      }
  }

*/
